<script setup>
import { dateRanges } from '../helpers/DatePickerHelper';

defineProps({
  selectedRange: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['setRange']);

const setDateRange = range => {
  emit('setRange', range);
};
</script>

<template>
  <div class="flex min-w-0 w-full flex-col items-start md:w-48 md:shrink-0">
    <h4
      class="mb-0 w-full px-4 py-3 text-xs font-semibold capitalize text-start text-n-slate-10"
    >
      {{ $t('DATE_PICKER.DATE_RANGE_OPTIONS.TITLE') }}
    </h4>
    <div class="grid grid-cols-2 items-start w-full md:flex md:flex-col">
      <template v-for="range in dateRanges" :key="range.label">
        <div
          v-if="range.separator"
          class="hidden md:block w-full border-t border-n-weak"
        />
        <button
          class="w-full px-4 py-3 text-sm font-medium truncate border-none rounded-none text-start hover:bg-n-alpha-2 dark:hover:bg-n-solid-3"
          :class="
            range.value === selectedRange
              ? 'text-n-slate-12 bg-n-alpha-1 dark:bg-n-solid-active'
              : 'text-n-slate-12'
          "
          @click="setDateRange(range)"
        >
          {{ $t(range.label) }}
        </button>
      </template>
    </div>
  </div>
</template>
